export enum SentimentLabel {
  Negative = 0,
  Mixed    = 1,
  Neutral  = 2,
  Positive = 3,
}
